import React, { useState, Component ,useEffect }  from 'react';
import { Button ,Modal,Spin,Form,Input } from 'antd';
import { useHistory ,Link} from 'react-router-dom';
// import { useAuth } from './AuthContext';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import LinkButton from '../../components/link-button';
import { UserOutlined, LockOutlined ,EyeInvisibleOutlined, EyeTwoTone, } from '@ant-design/icons';
import {reqLogin,reqGoogleToken} from '../../api';
import {saveLoginToLocalStorage} from '../utils/storageUtils'
import CryptoJS from 'crypto-js';
import logo from '../../assets/image/logo.png'
import './login.less';



// const validatePassword = (_, value) => {
//     if (!value) {
//       return Promise.resolve();
//     }else{
//         const letterCount = (value.match(/[a-zA-Z]/g) || []).length;
//         const numberCount = (value.match(/\d/g) || []).length;
//         if (letterCount < 1 || numberCount < 1 || value.length < 6 || value.length > 15) {
//           return Promise.reject(new Error("英文字と数字を含む、6-15桁文字で入力してください。"));
//         }
//         return Promise.resolve();
//     }
    
//   };


const LoginForm = () => {
    const [loginForm] = Form.useForm();
    const [loginDisabled, setLoginDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [lockFlag, setLockFlag] = useState(false);
    const history = useHistory();
  
    useEffect(() => {
     }, []);
  
  
    const onLoginFinish = async (values) => {
          const {mailAddress, password} = values    
          setLoading(true)    
          setErrorMsg('')
          setLockFlag(false)
          const encryptedPassword = CryptoJS.SHA256(password).toString();
          const result =  await reqLogin(mailAddress, encryptedPassword)
          if (result.status===0) { 
              saveLoginToLocalStorage(result.data)
              history.push('/');
          }else if (result.status===1002) {
            setLockFlag(true)
          }else{
              setErrorMsg(result.data)
          }
          setLoading(false)
      };
      
      const loginFormValuesChange = () => {
          setErrorMsg('')
          setLockFlag(false)
          setTimeout(() => {
              const hasErrors = loginForm.getFieldsError().some(({ errors }) => errors.length > 0);
              const values = loginForm.getFieldValue();
              setLoginDisabled(hasErrors || values.mailAddress.trim() === "" || values.password.trim() === "");
            }, 100);
        };
  
      const createAccountClick = () => {
        history.push('/regist');
      };
  
      const changePwdClick = () =>{
        history.push('/reset');
      };
  
  
      const handleGoogleLoginSuccess = async(response) => {   
        setLoading(true)        
  
          const result =  await reqGoogleToken(response.credential)
          if (result.status===0) {     
            saveLoginToLocalStorage(result.data)
            history.push('/');
          }else{
              setErrorMsg('Googleアカウントのログインに失敗しました。')
          }
          setLoading(false)    
      };
  
      const spinStyle = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          zIndex: 1000,
          overflow: 'auto',
      };
  
    return (
      <>
      <Modal
        style={{
            top: 0,
            }}
          title={null}
          footer={null}
          visible={true}   
          maskClosable={false}
          closable={false}
          maskStyle={{ backgroundColor: 'white' }}
        >
        {loading && <div style={spinStyle}>
                        <Spin spinning={loading} size="large" />
                        </div>}
                        <Form
                        layout="vertical"
                        form={loginForm}
                        name="normal_login"
                        className="login-form"
                        onValuesChange={loginFormValuesChange}
                        onFinish={onLoginFinish}
                        >
                        <Form.Item>
                            <div className="login-header" >
                                <img  src={logo} alt=''></img>
                                <div className="title">クラウドオズ</div>
                            </div>
                        </Form.Item>
                        <Form.Item
                            label={<span className='login-form-title'>メールアドレス</span>}
                            name="mailAddress"
                            rules={[{ required:true, message:"入力は必須です。" },
                                    { type:'email', message:"有効なメールアドレスを入力してください。" }]}
                            initialValue=""
                        >
                            <Input className="login-form-item"　prefix={<UserOutlined className="site-form-item-icon" />} />
                        </Form.Item>
                        <Form.Item
                            label={<span className='login-form-title'>パスワード</span>}
                            name="password"
                            rules={[{ required:true, message:"入力は必須です。" }]}
                            initialValue=""
                        >
                            <Input.Password
                            className="login-form-item"　
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            />
                        </Form.Item>
                        {errorMsg!=='' && <Form.Item className="login-form-error">
                            <span >{errorMsg}</span>
                        </Form.Item>}
                        {lockFlag && <Form.Item className="login-form-error">
                            <span >パスワード不正のためロックしました。<Link to="/reset" style={{ textDecoration: 'underline' }}>パスワード再設定</Link>してください。</span>
                        </Form.Item>}
                        <Form.Item >
                            <Button type="primary" htmlType="submit" className="login-form-button" disabled={loginDisabled}>
                            ログイン
                            </Button>
                        </Form.Item>
                        

                        <Form.Item >                            
                            <div style={{width:'100%',display:'flex',flexDirection:'column',justifyContent:'flex-start'}}>
                                <div>
                                    <LinkButton onClick={changePwdClick}>パスワードを忘れた方はこちら</LinkButton>
                                </div>
                                <div>
                                    <span style={{marginLeft:'5px'}}>アカウントがありませんか？</span>
                                    <LinkButton onClick={createAccountClick}>無料登録</LinkButton>
                                </div>
                                
                            </div>
                        </Form.Item>

                        

                        {/* <Form.Item >                            
                            <WhiteButton >Appleアカウントで続行</WhiteButton>
                        </Form.Item> */}
                        <Form.Item >
                        
                            {/* <GoogleOAuthProvider clientId="50102715769-65cncdj4hlaim5nn25kktglh061070hm.apps.googleusercontent.com" style={{width: '100%'}}></GoogleOAuthProvider> */}
                            <GoogleOAuthProvider clientId="395157237602-5nfi2cgfe338h3f9j58bvbfh3b3g51q1.apps.googleusercontent.com" style={{width: '100%'}}>
                                <GoogleLogin style={{width: '100%'}}
                                onSuccess={handleGoogleLoginSuccess}
                                onError={() => setErrorMsg('Googleアカウントのログインに失敗しました。')}
                                />
                            </GoogleOAuthProvider>
                        </Form.Item>
                    </Form>   
        </Modal>        
        </>
    );
  }

export default class Login extends Component {
    render() {
        document.title = 'ログイン'
      return (
            <LoginForm />
      );
    }
  }
  



